import { ReactNode, useState } from 'react'

export interface Item {
  value: string
  label: string
  icon?: ReactNode
}

interface ItemListProps {
  items: Item[]
  onChange?: (selectedItem: Item) => void
  defaultValue?: string
  disabled?: boolean
}

export const ItemList = ({
  items,
  onChange,
  defaultValue,
  disabled = false
}: ItemListProps) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(defaultValue || null)
  
  const handleItemSelect = (item: Item) => {
    if (disabled) return
    setSelectedValue(item.value)
    onChange?.(item)
  }

  return (
    <div className="border border-border rounded-lg bg-card overflow-hidden">
      {items.map((item, index) => {
        const isSelected = selectedValue === item.value
        
        return (
          <div
            key={item.value}
            onClick={() => handleItemSelect(item)}
            className={`
              px-4 py-2 transition-all duration-200 text-sm flex items-center gap-2
              ${index !== items.length - 1 ? 'border-b border-border' : ''}
              ${disabled 
                ? 'cursor-not-allowed text-muted opacity-50' 
                : 'cursor-pointer'}
              ${!disabled && isSelected 
                ? 'bg-accent/20 text-accent shadow-sm' 
                : !disabled 
                  ? 'text-foreground hover:bg-accent/10 hover:text-accent hover:shadow-md hover:shadow-accent/15'
                  : ''
              }
            `}
          >
            {item.icon && (
              <span className="flex items-center justify-center w-4 h-4">{item.icon}</span>
            )}
            {item.label}
          </div>
        )
      })}
    </div>
  )
}